import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { Loader } from 'ui';
import { useEffect, useState } from 'react';
import { ASSESMENT_PLATFROM_CLIENT_ID, ASSESS_PLATFORM_FRONTEND } from 'src/config/env.config';
import { useGetPracticeSessionQuestionById } from 'src/hooks/prepPlan.hooks';
import { useMutation } from 'react-query';
import { verifyPracticeJwt } from 'src/apis/user';
import { useThemeContext } from 'src/context/ThemeProvider';
import NewCreatingPositionLoader from '../position/NewCreatingPositionLoader';

interface Props {
	className?: string;
}

const PracticeQuestionsScreen = ({ className }: Props) => {
	const { themeMode } = useThemeContext();
	const { questionId, assessQuestionId } = useParams();
	const [token, setToken] = useState('');
	const { data, isLoading: practiceSessionLoading } = useGetPracticeSessionQuestionById(
		assessQuestionId || '',
		questionId || '',
		data => {
			if (data && data.data) {
				const payload = {
					questionId: `${data.data.assessQuestionId}`,
					token: data.data.assessToken || '',
				};
				fetchJwtTokenForPracticeFn.mutate(payload);
			}
		},
	);

	const fetchJwtTokenForPracticeFn = useMutation(['verifyPracticeJwt'], verifyPracticeJwt, {
		onSuccess(data) {
			if (data && data.token) {
				setToken(data.token);
			}
		},
	});

	useEffect(() => {
		window.addEventListener('message', e => {
			const data = e.data;
			if (data.type === 'all-test-cases-passed') {
				// setShowNextQuestionModal(true);
			}

			if (data.type === 'current-question') {
			}
		});
	}, []);

	if (!data || practiceSessionLoading)
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="w-[40%] mx-auto" />
		);
	return (
		<>
			<div className={classNames('dark:bg-[#1C1C28] isolate', className)}>
				<iframe
					title="prep-plan-practice-screen"
					className="absolute bottom-0 left-0 right-0 top-0 h-[100vh] w-[100vw]"
					src={`${ASSESS_PLATFORM_FRONTEND}/practice?jwt=${token}&clientId=${ASSESMENT_PLATFROM_CLIENT_ID}${
						themeMode === 'dark' ? `&dark=1` : `&dark=0`
					}`}
				></iframe>
			</div>
		</>
	);
};

export default PracticeQuestionsScreen;
